import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { serverGET, serverPOST } from "../HttpFunctions";
import { errorNotfiy, successNotfiy } from "@/components/Global/Toast";

const useDropdownData = (type = "") => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (spec) => serverPOST(`/lists`, spec),
    onError: (error, variables, context) => {
      errorNotfiy(
        error.message || "Something went wrong while creating list item"
      );
    },
    onSuccess: (data, variables: any, context) => {
      queryClient.setQueryData(["dropdownData"], (oldData: any) => {
        return {
          ...oldData,
          [variables.identifier]: [
            ...(oldData?.[variables.identifier] || []),
            { value: variables.value, label: variables.label },
          ],
        };
      });
      successNotfiy("Success: New item is added", () => {});
    },
  });

  const { data = [] } = useQuery({
    queryKey: ["dropdownData"],
    queryFn: () => serverGET("/lists"),
    staleTime: Infinity,
    gcTime: Infinity,
    // gcTime: 30 * 60 * 1000, // 30 minutes
  });

  return {
    data,
    mutate,
    isPending,
  };
};

export default useDropdownData;
